module.exports = __webpack_public_path__ + "img/info-circle.49f2129b.svg";